// src/views/templates/TemplateForm/utils/buildCarouselCards.js
/**
 * Construye el array `cards` del payload CAROUSEL a partir del estado del formulario.
 * Cada card conserva su propia imagen (mediaFile -> data-URI) y sus botones.
 * El tipo de cada botón se toma del array global buttonTypes (por índice); la card
 * nunca guarda su propio tipo de botón, así que leerlo de la card es un bug.
 */
const buildCarouselCards = async (carouselCards = [], buttonTypes = [], fileToMediaString) => {
    const formattedCards = [];

    for (const card of carouselCards) {
        const headerType = card.headerType?.toUpperCase() || "IMAGE";
        const mediaUrl =
            card.mediaFile && fileToMediaString
                ? await fileToMediaString(card.mediaFile)
                : null;

        let bodyText = card.description || "";
        (card.variables || []).forEach((v) => {
            if (v.name && v.sample) bodyText = bodyText.replaceAll(v.name, v.sample);
        });

        const buttons = [];
        for (let i = 0; i < 3; i++) {
            const title = card[`button_${i}_title`];
            const value = card[`button_${i}_value`];
            if (!title) continue;

            const btnType = (buttonTypes[i] || "quick_reply").toUpperCase();
            switch (btnType) {
                case "URL": {
                    const url =
                        value && !value.includes("{{1}}")
                            ? `${value}?promo={{1}}`
                            : value || "https://example.com?promo={{1}}";
                    // Prefijo de la URL antes de {{N}}, INCLUYE "?promo=" (contrato Gupshup).
                    const buttonValue = url.split("{{")[0];
                    const suffix = "promo_suffix";
                    buttons.push({
                        type: "URL",
                        text: title,
                        url,
                        buttonValue,
                        suffix,
                        example: [`${buttonValue}${suffix}`],
                    });
                    break;
                }
                case "PHONE":
                    buttons.push({
                        type: "PHONE_NUMBER",
                        text: title,
                        phone_number: value || "+521234567890",
                    });
                    break;
                default:
                    buttons.push({type: "QUICK_REPLY", text: title || "Button"});
            }
        }

        formattedCards.push({
            headerType,
            mediaUrl,
            body: card.description || "",
            sampleText: bodyText || card.description,
            buttons,
        });
    }

    return formattedCards;
};

export default buildCarouselCards;
